import { css } from '@emotion/react';
import { Tooltip } from '@mui/material';
import { ColDef, ICellRendererParams } from 'ag-grid-community';
import { colors } from '../../../theme/colors';
import { IPortfolioTreeRow } from './computeTreeRows';

const structureCellStyles = css`
  display: inline-flex;
  align-items: center;
  gap: 0.4rem;
  min-width: 0;
`;

const labelStyles = css`
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`;

const incompleteStyles = css`
  color: ${colors.warning[60]};
  font-size: 13px;
  line-height: 1;
  cursor: default;
`;

export function TreeGroupCell({ data, value }: ICellRendererParams<IPortfolioTreeRow>) {
  if (!data) {
    return <span>{value}</span>;
  }

  return (
    <span css={structureCellStyles}>
      <span css={labelStyles}>{data.treeLabel}</span>
      {data.treeIncomplete && (
        <Tooltip title='Incomplete: unattributed transactions, or a vehicle value that is missing or not counted here'>
          <span css={incompleteStyles} role='img' aria-label='Incomplete attribution'>
            ⚠
          </span>
        </Tooltip>
      )}
    </span>
  );
}

export const treeAutoGroupColumnDef: ColDef<IPortfolioTreeRow> = {
  headerName: 'Structure',
  minWidth: 320,
  pinned: 'left',
  lockPinned: true,
  menuTabs: ['filterMenuTab'],
  // The group cell's "(N)" counts ag-grid's children, which in tree mode is the vehicles
  // under a fund rather than anything a reader would call a count.
  cellRendererParams: { suppressCount: true, innerRenderer: TreeGroupCell },
  valueGetter: (params) => params.data?.treeLabel ?? '',
  getQuickFilterText: (params) => params.data?.treeLabel ?? '',
};
